import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, IconButton } from "@material-ui/core";
import { InputBase, Divider } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";

const useStyles = makeStyles((theme) => ({
  paperForm: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    borderRadius: 30,
  },
  searchIconBox: {
    display: "flex",
    marginRight: "10px",
    marginLeft: "10px",
  },
  searchField: {
    width: "100%",
  },
  dividerBar: {
    height: 20,
    margin: 4,
  },
}));

function SearchingForm(props) {
  const classes = useStyles();

  return (
    <form
      onSubmit={(e) => {
        props.searchSubmitHandler(e);
      }}
    >
      <Paper elevation={0} variant="outlined" className={classes.paperForm}>
        <div className={classes.searchIconBox}>
          <SearchIcon color="action" />
        </div>
        <InputBase
          className={classes.searchField}
          placeholder="Local Tracking Number"
          onChange={(e) => {
            props.searchFieldHandler(e);
          }}
          value={props.trackingNumber || ""}
        />

        <Divider className={classes.dividerBar} orientation="vertical" />
        <IconButton onClick={props.searchSubmitHandler}>
          <KeyboardReturnIcon />
        </IconButton>
      </Paper>
    </form>
  );
}

export default SearchingForm;
